<!-- src/components/ui/LoadingOverlay.vue -->
<template>
  <Teleport to="body">
    <div class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
      <div class="bg-slate-800 rounded-lg p-8 border border-slate-700 text-center">
        <svg class="animate-spin h-12 w-12 text-blue-500 mx-auto mb-4" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <p class="text-white font-medium">{{ message || 'Carregando...' }}</p>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
defineProps({
  message: {
    type: String,
    default: 'Carregando...'
  }
})
</script>